import React, { Component } from 'react';

class IconClosedEye extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="22.828" viewBox="0 0 22.828 22.828">
                <g id="Icon_feather-eye-off" data-name="Icon feather-eye-off" transform="translate(-0.086 -0.086)">
                    <path id="Path_6397" data-name="Path 6397" d="M16.9,15.584A11.17,11.17,0,0,1,11.5,17c-6.364,0-10-5.5-10-5.5A14.45,14.45,0,0,1,6.1,7.416M9.591,6.165A10.857,10.857,0,0,1,11.5,6c6.364,0,10,5.5,10,5.5a13.208,13.208,0,0,1-1.964,2.193m-6.109-.736a3.329,3.329,0,0,1-2.67.592A2.488,2.488,0,0,1,8.79,12.062a1.764,1.764,0,0,1,.783-2.019" transform="translate(0 0)" fill="none" stroke="#4e5b65" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    <path id="Path_6398" data-name="Path 6398" d="M1.5,1.5l20,20" fill="none" stroke="#4e5b65" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                </g>
            </svg>
        );
    }
}

export default IconClosedEye;